import {Permission} from './acl';

export const PANEL_CODES = [
  'HazardAI',
  'HazardAIDectionLog',
  'HazardAIMachineUtilizationChart',
  'HazardAIMachineSpeedChart',
  'HazardAISummaryChart',
  'HazardAIMachineInteractions',
  'HazardAIMachineLocationHistory',
  'HazardAIDailyBreakdown',
  'HazardHeatMapReports',
  'Map',
  'AlarmHistoryReports',
  'AlarmLogReports',
  'AlarmGrid',
  'CnWifiNodes',
  'EmployeeAssetsGrid',
  'MachineDetailsReport',
  'MachineOverviewReport',
  'MachineHistoryReport',
  'MachineStatusReport',
  'EmployeeHistoryReport',
  'EmployeeOverviewReport',
  'MachineInteractionReport',
  'MachineSummaryReport',
  'CheckoutStationOverviewReport',
  'CheckoutStationDetailsReport',
  'InteractionsPerMachine',
  'TopEmployeeInteractions',
  'ConnectView',
  'MCronLogs',
  'MProcessorLogs',
  'SystemServicesTable',
  'CommtracNodeTrackingReports',
  'NodeTrackingReports',
  'NetworkDiagnostics',
  'BackHaulers',
  'SentroGateway',
  'InteractionsLastDays',
  'Nginx',
  'Backend',
  'Mqtt',
  'GasMonitoringReport',
  'AmsEmoduleInstallationHistory',
  'AmsEmoduleSensorHistory',
  'AMSEModuleCalibration',
  'BeltHistoryReport',
  'BeltLocationHistoryReport',
  'ShaftClearance',
  'ShaftClearanceReport',
  'AMSShortTermHistoryReport',
  'AMSLongTermHistoryReport',
  'AMSLocationHistoryReport',
  'MachineDetectionsByCamera',
  'TimeOfDayDetections',
] as const;

export type PanelCode = (typeof PANEL_CODES)[number];

export const PANEL_PRODUCT_CODES = [
  'core',
  'connect',
  'wifi',
  'belts',
  'proximity',
  'ams',
  'shaft_clearance',
  'ventilation',
  'hazard',
  'alarm',
] as const;

export type PanelProductCode = (typeof PANEL_PRODUCT_CODES)[number];

export const PANELS_DATA: {
  [key in PanelCode]: {
    products: PanelProductCode[];
    permissions?: Permission[];
    roles?: number[];
    accessChecker?: () => boolean;
  };
} = {
  MachineDetailsReport: {
    products: ['proximity'],
  },
  MachineOverviewReport: {
    products: ['proximity'],
  },
  MachineHistoryReport: {
    products: ['proximity'],
  },
  MachineStatusReport: {
    products: ['proximity'],
  },
  EmployeeHistoryReport: {
    products: ['proximity'],
  },
  EmployeeOverviewReport: {
    products: ['proximity'],
  },
  MachineInteractionReport: {
    products: ['proximity'],
  },
  MachineSummaryReport: {
    products: ['proximity'],
  },
  CheckoutStationOverviewReport: {
    products: ['proximity'],
  },
  CheckoutStationDetailsReport: {
    products: ['proximity'],
  },
  InteractionsPerMachine: {
    products: ['proximity'],
  },
  TopEmployeeInteractions: {
    products: ['proximity'],
  },
  ConnectView: {
    products: ['connect'],
  },
  HazardAI: {
    products: ['hazard'],
  },
  HazardAIDectionLog: {
    products: ['hazard'],
  },
  HazardAIMachineUtilizationChart: {
    products: ['hazard'],
  },
  HazardAIMachineSpeedChart: {
    products: ['hazard'],
  },
  HazardAISummaryChart: {
    products: ['hazard'],
  },
  HazardAIMachineInteractions: {
    products: ['hazard'],
  },
  HazardHeatMapReports: {
    products: ['hazard'],
    permissions: ['get::/hazard-ai/detection-heat-map'],
  },
  HazardAIMachineLocationHistory: {
    products: ['hazard'],
  },
  HazardAIDailyBreakdown: {
    products: ['hazard'],
  },
  Map: {
    products: ['connect'],
  },
  InteractionsLastDays: {
    products: ['proximity'],
  },
  MCronLogs: {
    products: ['core'],
    permissions: ['get::/m-cron/status'],
  },
  MProcessorLogs: {
    products: ['core'],
    permissions: ['get::/m-processor/get-logs'],
  },
  SystemServicesTable: {
    products: ['core'],
    permissions: ['get::/system/status'],
  },
  CommtracNodeTrackingReports: {
    products: ['connect'],
  },
  NodeTrackingReports: {
    products: ['connect'],
  },
  NetworkDiagnostics: {
    products: ['connect'],
  },
  BackHaulers: {
    products: ['core'],
    permissions: ['get::/backhauler'],
  },
  SentroGateway: {
    products: ['ams'],
  },
  AlarmHistoryReports: {
    products: ['alarm'],
  },
  AlarmLogReports: {
    products: ['alarm'],
  },
  AlarmGrid: {
    products: ['alarm'],
  },
  CnWifiNodes: {
    products: ['connect'],
  },
  EmployeeAssetsGrid: {
    products: ['connect'],
  },
  Nginx: {
    products: ['core'],
    permissions: ['get::/backend/frontend/summary'],
  },
  Backend: {
    products: ['core'],
    permissions: ['get::/backend/summary'],
  },
  Mqtt: {
    products: ['core'],
    permissions: ['get::/backend/mqtt/summary'],
  },
  GasMonitoringReport: {
    products: ['ams'],
  },
  AmsEmoduleInstallationHistory: {
    products: ['ams'],
  },
  AmsEmoduleSensorHistory: {
    products: ['ams'],
  },
  AMSEModuleCalibration: {
    products: ['ams'],
  },
  BeltHistoryReport: {
    products: ['belts'],
  },
  BeltLocationHistoryReport: {
    products: ['belts'],
  },
  ShaftClearance: {
    products: ['shaft_clearance'],
  },
  ShaftClearanceReport: {
    products: ['shaft_clearance'],
  },
  AMSShortTermHistoryReport: {
    products: ['ams'],
  },
  AMSLongTermHistoryReport: {
    products: ['ams'],
  },
  AMSLocationHistoryReport: {
    products: ['ams'],
  },
  MachineDetectionsByCamera: {
    products: ['hazard'],
  },
  TimeOfDayDetections: {
    products: ['hazard'],
  },
};
